import React from 'react'
import { loadOrgMailroomSettings, updateOrgMailroomSettings } from './api/organization'
import MailroomSettingsForm from './MailroomSettingsForm'

export default function OrgMailroomSettings({ organizationId }) {
  return (
    <MailroomSettingsForm
      loadFn={() => loadOrgMailroomSettings(organizationId)}
      saveFn={(params) => updateOrgMailroomSettings(organizationId, params)}
    />
  )
}
